import { useState } from "react";
import ChatSidebarPortal from "./portals/ChatSidebarPortal";
import WikiSidebarPortal from "./portals/WikiSidebarPortal";
import FeedSidebarPortal from "./portals/FeedSidebarPortal";
import HomeSidebarPortal from "./portals/HomeSidebarPortal";
import GraphSidebarPortal from "./portals/GraphSidebarPortal";
import ReportsSidebarPortal from "./portals/ReportsSidebarPortal";
import EmptyPortal from "./portals/EmptyPortal";
import PopUpSearch from "../../Panels/PopUpSearch";
import useSharedSearchItems from "../Search/useSharedSearchItems";

const SidebarPortals = () => {
  useSharedSearchItems();
  const [showAddCompany, setShowAddCompany] = useState(false);
  const [triggerReload, setTriggerReload] = useState(false);
  return (
    <>
      <ChatSidebarPortal />
      <WikiSidebarPortal onAddCompany={() => setShowAddCompany(true)} triggerReload={triggerReload} />
      <FeedSidebarPortal />
      <HomeSidebarPortal />
      <GraphSidebarPortal />
      <ReportsSidebarPortal />
      <EmptyPortal slotId="explorer-portal-slot" />
      {showAddCompany && (
        <PopUpSearch
          setAddCompanyMenu={setShowAddCompany}
          triggerThreadReload={triggerReload}
          setTriggerThreadReload={setTriggerReload}
        />
      )}
    </>
  );
};

export default SidebarPortals;
